import { render, staticRenderFns } from "./device-add.vue?vue&type=template&id=5937a13a&scoped=true"
import script from "./device-add.vue?vue&type=script&lang=js"
export * from "./device-add.vue?vue&type=script&lang=js"
import style0 from "./device-add.vue?vue&type=style&index=0&id=5937a13a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5937a13a",
  null
  
)

export default component.exports